import * as React from "react"
import { PageContext } from "../../context/pageProvider"
import LazyLoad from "react-lazy-load"

const Footer = () => {
  const { meta } = React.useContext(PageContext)

  const { nimbata, showAddictiveLogo } = meta.settings
  const {
    isAddressShown,
    companyadress,
    companypostalcode,
    companyemail,
    companyorg,
    footerTitle,
    title,
    companyNameUrl,
  } = meta.client
  return (
    <>
      <div className="cols italic">
        <div
          className={`flex flex-col md:flex-row flex-wrap elva p-[30px] ${
            isAddressShown ? "justify-between" : ""
          }`}
        >
          <div className={isAddressShown ? "" : "firstBlock"}>
            <h3>
              <strong>{meta.translations?.om_oss || "Om oss"}</strong>
            </h3>
            <p className="mt-2.5">{footerTitle}</p>
            {companyNameUrl ? (
              <a href={`https://www.${companyNameUrl}`} target="_blank">
                {title}
              </a>
            ) : (
              <p>{title}</p>
            )}
            {companyorg && <p>{companyorg}</p>}
          </div>
          <div className="mt-8 md:mt-0">
            <h3>
              <strong>{meta.translations?.kontakter || "Kontakter"}</strong>
            </h3>
            {companyemail && (
              <p className="mt-2.5">
                {meta.translations?.mejl || "Mejl"}:
                <a href={`mailto:${companyemail}`}> {companyemail}</a>
              </p>
            )}
            {nimbata && (
              <p>
                {meta.translations?.telefon || "Telefon"}:
                <a href={`tel:${nimbata}`}>{nimbata}</a>{" "}
              </p>
            )}
          </div>
          {isAddressShown && (
            <div className="col mt-8 md:mt-0">
              <h3>
                <strong>Hitta hit</strong>
              </h3>
              <p className="mt-2.5 mb-1.5">{companyadress}</p>
              <p>{companypostalcode}</p>
            </div>
          )}
        </div>
      </div>
      <div className="elva flex justify-between italic">
        <div className="sm:p-8 p-4">
          <p className="my-5">
            <a
              href="https://addictive-production-store.s3.eu-north-1.amazonaws.com/files/integritetespolicy1-0.pdf"
              target="_blank"
              title="Integritetspolicy"
              rel="noopener"
            >
              Integritetspolicy
            </a>
            {" & "}
            <a
              target="_blank"
              rel="noopener"
              href="https://addictive-production-store.s3.eu-north-1.amazonaws.com/files/cookiepolicy.pdf"
              title="cookiepolicy"
            >
              Cookies
            </a>
          </p>
        </div>
        {showAddictiveLogo !== false && (
          <div className="p-4 sm:p-8 footer-grey flex items-center">
            <p className="text-right my-0">
              Sidan ägs och administreras av: <br />
              <LazyLoad>
                <img
                  className="max-w-full h-full  ml-auto"
                  height="22"
                  width="220"
                  src="https://sites-files-addictive.s3.eu-north-1.amazonaws.com/logo.png"
                />
              </LazyLoad>
            </p>
          </div>
        )}
      </div>
    </>
  )
}

export default Footer
